var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4414,
    cy: 24.2275,
    r: 23.5,
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4352_15582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8138 36.2273H12.8377V20.2039H17.8138V36.2273ZM15.3231 18.0172C14.7504 18.0199 14.1898 17.8527 13.7122 17.5368C13.2345 17.2209 12.8613 16.7704 12.6397 16.2424C12.418 15.7143 12.358 15.1324 12.4671 14.5702C12.5762 14.008 12.8496 13.4908 13.2527 13.084C13.6557 12.6772 14.1704 12.3991 14.7316 12.2848C15.2927 12.1705 15.8751 12.2252 16.4052 12.4419C16.9353 12.6587 17.3892 13.0278 17.7095 13.5025C18.0298 13.9772 18.2021 14.5362 18.2047 15.1089C18.2053 15.8758 17.9028 16.6119 17.363 17.1567C16.8232 17.7014 16.09 18.0108 15.3231 18.0172ZM36.4369 36.2273H31.4714V28.4274C31.4714 26.5683 31.4341 24.1842 28.8808 24.1842C26.2903 24.1842 25.8971 26.2041 25.8971 28.2933V36.2273H20.9309V20.2039H25.7028V22.3899H25.7752C26.252 21.5724 26.9418 20.8997 27.7709 20.4435C28.6 19.9873 29.5375 19.7646 30.4832 19.7993C35.5188 19.7993 36.4445 23.1153 36.4445 27.4224V36.2273H36.4369Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4352_15582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0008,
    height: 24,
    fill: "white",
    transform: "translate(12.4414 12.2275)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5dc0452493246928af838696dce7190c.svg";
export { ForwardRef as ReactComponent };